export default "__VITE_ASSET__BOPdwGvn__"